export default __webpack_public_path__ + "static/media/background_aae_hud_factory_features.c7edf482.jpg";